exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "footer.footer {\n  text-align: center;\n  padding: 30px 0;\n  margin-top: 70px;\n  border-top: 1px solid #E5E5E5; }\n", "", {"version":3,"sources":["/Users/jean-philippe/_work/rs-webapp/rs-lightbox-old/client/app/layout/footer/footer.scss"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B,EAAE","file":"footer.scss","sourcesContent":["footer.footer {\n  text-align: center;\n  padding: 30px 0;\n  margin-top: 70px;\n  border-top: 1px solid #E5E5E5; }\n"],"sourceRoot":""}]);

// exports
